import { jsx as _jsx } from "react/jsx-runtime";
import { StyleSheet } from 'react-native';
import { theme } from '@xbto/design-system';
import { TableRow } from '../table-row';
export function TableHeaderRow(props) {
    return _jsx(TableRow, Object.assign({}, props, { style: $.container }));
}
const $ = StyleSheet.create({
    container: {
        height: 36,
        backgroundColor: theme.color.background.white,
        borderColor: theme.color.border.primary,
        bordertopWidth: 1,
        borderTopLeftRadius: theme.radius.md,
        borderTopRightRadius: theme.radius.md,
    },
});
